import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.planning')
  .factory('$planningProjectsProcessTracking', planningProjectsProcessTrackingObjectFactory);

/* @ngInject */
function planningProjectsProcessTrackingObjectFactory($bringozFactory: $bringozFactory,
                                                      PlanningProjectsProcessTrackingAPI: BringozApi,
                                                      Planning_Projects_Process_Tracking_DS: DataStoreConfig,
                                                      Planning_Projects_Process_Tracking_PN: PushNotificationsConfig) {

  function $planningProjectsProcessTracking(id: string) {
    return $bringozFactory(id, PlanningProjectsProcessTrackingAPI, Planning_Projects_Process_Tracking_DS, Planning_Projects_Process_Tracking_PN)
  }
  return $planningProjectsProcessTracking
}
